import { React } from 'react';

interface logoProps {
  size ?: number
}

const PyroLogo = ({size = 30}): logoProps => {
  return (
    <svg
      aria-label="Pyro logo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
      width={size}
      height={size}
    >
      <path
        d="M6.21745 17.6753C6.21745 17.2432 6.21745 17.0271 6.25365 16.8475C6.40229 16.1097 6.98645 15.5331 7.7337 15.3863C7.9157 15.3505 8.13451 15.3505 8.5722 15.3505C9.00988 15.3505 9.22869 15.3505 9.41062 15.3863C10.158 15.5331 10.7421 16.1097 10.8908 16.8475C10.927 17.0271 10.927 17.2432 10.927 17.6753V18.4502C10.927 19.0295 10.927 19.3192 10.8007 19.535C10.7181 19.6764 10.5992 19.7937 10.456 19.8753C10.2374 19.9999 9.94401 19.9999 9.35709 19.9999H7.7873C7.2004 19.9999 6.90697 19.9999 6.6884 19.8753C6.54521 19.7937 6.42631 19.6764 6.34364 19.535C6.21745 19.3192 6.21745 19.0295 6.21745 18.4502V17.6753Z"
        fill="none"
        stroke="currentcolor"
        stroke-width="1.3"
      ></path>
      <path
        d="M2.68754 19.9999H4.30125C4.48396 19.9999 4.57532 19.9999 4.62243 19.9426C4.66955 19.8853 4.64981 19.7928 4.61034 19.6079C3.05642 12.3286 10.242 13.9651 11.2824 8.92871C11.8133 6.3583 10.3019 2.90823 10.3912 0.511022C10.4023 0.210555 10.4079 0.0603227 10.3256 0.0137585C10.2433 -0.0328057 10.1244 0.0419013 9.88668 0.191315C6.52794 2.3019 4.08025 6.33654 4.97481 8.81197C5.11156 9.19041 5.17994 9.3796 5.09347 9.44871C5.007 9.51782 4.86068 9.42871 4.56803 9.25056C4.09217 8.96093 3.52664 8.48671 3.13351 7.73953C3.01817 7.52034 2.96049 7.41071 2.87588 7.40246C2.79127 7.39418 2.71856 7.48353 2.57315 7.66219C-1.65298 12.8551 0.0596035 18.0408 2.50046 19.9375C2.53941 19.9677 2.55889 19.9829 2.58385 19.9914C2.60881 19.9999 2.63505 19.9999 2.68754 19.9999Z"
        fill="none"
        stroke="currentcolor"
        stroke-width="1.3"
      ></path>
      <path
        d="M13.2111 8.19338C13.4274 10.5791 11.9733 12.2109 10.3125 13.3414C10.0225 13.5387 9.87753 13.6374 9.89007 13.7314C9.90261 13.8254 10.0759 13.8863 10.4224 14.008C12.6369 14.7861 12.7375 17.0164 12.5542 19.6665C12.5434 19.8231 12.5379 19.9015 12.5845 19.9507C12.631 19.9999 12.7101 19.9999 12.8683 19.9999H14.2516C14.2935 19.9999 14.3145 19.9999 14.3348 19.9944C14.3551 19.9889 14.3731 19.9785 14.4091 19.9575C19.368 17.0699 16.7055 10.1722 13.6803 7.89531C13.4598 7.72931 13.3495 7.64635 13.2599 7.69516C13.1703 7.74405 13.1839 7.89383 13.2111 8.19338Z"
        fill="none"
        stroke="currentcolor"
        stroke-width="1.3"
      ></path>
    </svg>
  );
};

export default PyroLogo;